const DnDTypes = [
  'PARAGRAPH',
  'PROPERTY',
  'PROPERTIES_GROUP',
  'COMPARSION_PRODUCT',
]

export default DnDTypes.reduce((acc, curr) => ((acc[curr] = curr), acc), {})
